export const environment = () => process.env.NEXT_PUBLIC_ENV

export const isLocal = environment() === 'local'

export const isProduction = environment() === 'production'

export const isRunningTests = process.env.NODE_ENV === 'test'
